import { makeFetchSlice, sliceError } from './fetchSlice';

export function createBootWarning(code, message, detail = null) {
  return { code, message, detail };
}

export function isActiveSessionStatus(status) {
  const normalized = String(status || '').toLowerCase();
  return normalized === 'planned' || normalized === 'live';
}

export function createEmptyBootResult(bootWarnings, { loadsEvaluations = false } = {}) {
  const emptyCohorts = makeFetchSlice([]);
  const emptySessions = makeFetchSlice([]);
  const fatal = new Error('boot_fatal');

  return {
    loadsEvaluations,
    cohortFetch: sliceError(fatal, emptyCohorts, 'Could not load cohorts.'),
    sessionsFetch: sliceError(fatal, emptySessions, 'Could not load sessions.'),
    evaluationsFetch: loadsEvaluations
      ? sliceError(fatal, makeFetchSlice([]), 'Could not load evaluations.')
      : null,
    schoolCohortsMapNext: {},
    groupsBySchool: {},
    normalizedSessions: [],
    normalizedCohortEntities: [],
    normalizedEvaluations: [],
    rosters: {},
    rosterUpdates: [],
    reportsNext: [],
    cohortSummaries: [],
    sessionSummaries: [],
    bootWarnings,
    partial: true,
    fatal: true,
  };
}

export function computeBootPartial(bootWarnings, { cohortFetch, sessionsFetch, evaluationsFetch, loadsEvaluations }) {
  if (bootWarnings.length > 0) return true;
  if (cohortFetch?.status === 'error') return true;
  if (sessionsFetch?.status === 'error') return true;
  if (loadsEvaluations && evaluationsFetch?.status === 'error') return true;
  return false;
}